"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceRecordingTranscriptModelEnum = void 0;
var VoiceRecordingTranscriptModelEnum;
(function (VoiceRecordingTranscriptModelEnum) {
    VoiceRecordingTranscriptModelEnum["Nova"] = "nova";
    VoiceRecordingTranscriptModelEnum["Nova2"] = "nova-2";
    VoiceRecordingTranscriptModelEnum["Base"] = "base";
    VoiceRecordingTranscriptModelEnum["Whisper"] = "whisper";
    VoiceRecordingTranscriptModelEnum["Enhanced"] = "enhanced";
})(VoiceRecordingTranscriptModelEnum = exports.VoiceRecordingTranscriptModelEnum || (exports.VoiceRecordingTranscriptModelEnum = {}));
